import React, { Component } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export class BlogDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blog: null,
      seo: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.loadBlogDetail();
  }

  loadBlogDetail = async () => {
    try {
      const slug = window.location.pathname.split("/").pop();

      const formData = new FormData();
      formData.append("blogs_slug", slug);

      const response = await fetch(
        "https://idealtechnoride.in/api/blogdetail",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.length > 0) {
        const blog = data[0];

        const seoData = {
          seo_meta_title: blog.blogs_meta_title,
          seo_meta_keywords: blog.blogs_meta_keywords,
          seo_meta_description: blog.blogs_meta_description,
          seo_canonical_url: blog.blogs_canonical_url,
          seo_og_title: blog.blogs_og_title,
          seo_og_description: blog.blogs_og_description,
          seo_robots: blog.blogs_robots,
        };

        this.setState({
          blog: blog,
          seo: seoData,
          loading: false,
        });
      } else {
        this.setState({
          blog: null,
          loading: false,
        });
      }
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { blog, seo, loading } = this.state;

    if (loading) {
      return (
        <div className="container py-5 text-center">
          <h3>Loading...</h3>
        </div>
      );
    }

    if (!blog) {
      return (
        <div className="container py-5 text-center">
          <h3>Blog Not Found</h3>
        </div>
      );
    }

    return (
      <div>
        <SEO seo={seo} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">

              <div className="col-lg-8 text-center text-lg-start">
                <h1 className="display-4">
                  {blog.blogs_title}
                </h1>

                <p className="text-muted mt-3">
                  {blog.blogs_publish_date} • {blog.blogs_read_time}
                </p>
              </div>

              <div className="col-lg-4">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>

                    <li className="breadcrumb-item">
                      <Link to="/blogs">Blogs</Link>
                    </li>

                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      Blog Detail
                    </li>
                  </ol>
                </nav>
              </div>

            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Blog Content Start */}
        <div className="container py-5">

          {blog.blogs_banner_image && (
            <div className="mb-5">
              <img
                src={blog.blogs_banner_image}
                alt={blog.blogs_title}
                className="img-fluid rounded w-100"
              />
            </div>
          )}

          <div className="row">

            <div className="col-lg-8">

              <div className="mb-4">
                <h2>{blog.blogs_title}</h2>
              </div>

              {blog.blogs_short_description && (
                <div className="mb-4">
                  <p className="lead">
                    {blog.blogs_short_description}
                  </p>
                </div>
              )}

              <div className="mb-5">
                <h3>Blog Content</h3>

                <p
                  style={{
                    whiteSpace: "pre-line",
                  }}
                >
                  {blog.blogs_content}
                </p>
              </div>

              <div className="mb-4">
                <strong>Author:</strong>{" "}
                {blog.blogs_author}
              </div>

              <div className="mb-4">
                <strong>Read Time:</strong>{" "}
                {blog.blogs_read_time}
              </div>

              <div className="mb-5">
                <strong>Published Date:</strong>{" "}
                {blog.blogs_publish_date}
              </div>

              <Link
                to="/blogs"
                className="btn btn-primary"
              >
                Back To Blogs
              </Link>

            </div>

            <div className="col-lg-4">

              <div className="bg-light p-4 rounded">

                <h4 className="mb-4">
                  Blog Information
                </h4>

                <div className="mb-3">
                  <strong>Author</strong>
                  <br />
                  {blog.blogs_author}
                </div>

                <div className="mb-3">
                  <strong>Read Time</strong>
                  <br />
                  {blog.blogs_read_time}
                </div>

                <div className="mb-3">
                  <strong>Published</strong>
                  <br />
                  {blog.blogs_publish_date}
                </div>

              </div>

            </div>

          </div>

        </div>
        {/* Blog Content End */}
      </div>
    );
  }
}

export default BlogDetail;